import '../styles/Quotes.css'
import { columnsQuotes, columnsQuotesAdmin, columnsEmployeesAdmin, columnsCompositeproductAdmin, columnsCompositeproduct } from '../Component/Hooks/ColumTables'
import Table from '../Component/Tabla/Tabla'
import { useContext, useEffect, useState } from 'react'
import LoginContext from '../Context/Logincontext';
import { urlApiServer } from '../Config/Config'
import Loader from '../Component/Loader';
import EditEmployee from '../Component/Hooks/EditEmployee';
import EditCompositeProduct from '../Component/Hooks/EditCompositeProduct';

const CompositeProduct = () => {

    const urlgetCompositeproduct = urlApiServer + "getCompositeproduct"
    // const urlgetConfig = urlApiServer + "getConfig";

    const { infoUser } = useContext(LoginContext)
    const [compositeProduct, setCompositeProduct] = useState([])
    const [powerEdit, setPowerEdit] = useState(true)
    const [powerandoff, setPowerandoff] = useState(true)
    const [id, setId] = useState()
    const [disabledBottom] = useState(false);
    const [modify, setModify] = useState({})


    // useEffect(() => {
    //     (async function () {

    //         if (infoUser.login !== true) {
    //             window.location.href = './Login'
    //         }

    //         const InicioHeaders = new Headers();
    //         InicioHeaders.append("Content-Type", "application/json")

    //         const requesoption = {
    //             method: 'GET',
    //             headers: InicioHeaders,
    //             redirect: 'follow'
    //         }
    //         await fetch(urlgetConfig, requesoption).then(response => response.json()).then(quotesResponse => {
    //             // setOldConfig(quotesResponse)
    //         })
    //     }())


    // }, [])



    useEffect(() => {
        (async function () {
            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json");
            InicioHeaders.append("company", infoUser.company); // Enviar el nombre de la empresa como encabezado

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            };

            await fetch(urlgetCompositeproduct, requesoption)
                .then(response => response.json())
                .then(quotesResponse => {
                    setCompositeProduct(quotesResponse.reverse());
                })
                .catch(error => {
                });

            const InicioHeaders2 = new Headers();
            InicioHeaders2.append("Content-Type", "application/json");
            InicioHeaders2.append("company", infoUser.company); // Enviar el nombre de la empresa como encabezado

            const requesoption2 = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            };

        }())

    }, [urlgetCompositeproduct, powerEdit])

    useEffect(() => {
        if (disabledBottom) {
            if (powerandoff === true) {
                setPowerandoff(false)
            } else {
                setPowerandoff(true)
            }
        }
    }, [disabledBottom])

    async function handleModify(e) {
        setModify(e)
    }

    async function edit() {
        if (powerEdit === true) {
            setPowerEdit(false)
        } else {
            setPowerEdit(true)
        }
    }

    async function handleId(e) {
        setId(e)
    }

    return (
        <>
            {
                (infoUser.companyType === "Marmol") && (
                    (disabledBottom) && (
                        <div className="backgroundLoader">
                            <Loader />
                        </div>
                    )
                )
            }
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    (powerEdit === true) ? (
                        <>
                            {(infoUser.role === 'Administrador') ? (
                                <>

                                    <Table
                                        columns={columnsCompositeproductAdmin}
                                        data={compositeProduct}
                                        handleModify={handleModify}
                                        edit={edit}
                                        id={handleId}
                                    />
                                </>
                            ) : (
                                <>
                                    <Table
                                        columns={columnsCompositeproduct}
                                        data={compositeProduct}
                                        handleModify={handleModify}
                                        edit={edit}
                                        id={handleId}
                                    />
                                </>
                            )}
                        </>
                    ) : (
                        (<EditCompositeProduct id={id} data={modify} edit={edit} />)
                    )
                )
            ) : (<></>)}
        </>
    )
}

export default CompositeProduct